import { useFeatureFlags } from '../../contexts/FeatureFlagContext';
import { Feature } from '../../generated/graphql';
import { useAuth } from '../../contexts/AuthContext';

export const useStripeIntegration = () => {
  const { isFeatureEnabled } = useFeatureFlags();
  const { authedProviderUser } = useAuth();

  const isFeatureEnabledValue = isFeatureEnabled(Feature.StripeIntegration);
  const isConnected = Boolean(authedProviderUser?.provider.stripeAccountId);
  const canUseStripe = isFeatureEnabledValue && isConnected;

  return {
    isFeatureEnabled: isFeatureEnabledValue,
    isConnected,
    canUseStripe,
  };
};
